import { RouteConfig } from 'vue-router'

const Item = () => import('../views/physical-fitness-test/Item.vue')
const Index = () => import('../views/physical-fitness-test/Index.vue')

export const itemRoute: RouteConfig = {
  path: '/physical-fitness-test/item',
  name: 'physical_fitness_test_item',
  component: Item,
  props: (_route) => ({
    ..._route.query,
    ..._route.params,
    id: _route.query.id ? decodeURIComponent(_route.query.id as string) : '',
  }),
  meta: {
    title: '测试详情',
  },
}

export const indexRoute: RouteConfig = {
  path: '/physical-fitness-test',
  name: 'physical_fitness_test',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params, id: _route.query.upload_score_id }),
  meta: {
    title: '体测测试',
  },
}

export default [itemRoute, indexRoute]
